import type { AppState } from '@/store/store.ts';

export const selectOrderEmails = (state: AppState) => {
  return state.userPreferences.splitNotifications
    ? state.userPreferences.splitNotificationsEmailsOrders
    : state.userPreferences.emails;
};
